import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../design/Icon';
import { ThemeToggle } from '../components/shared/Button';
import { useHelp } from '../help/HelpContext';
import { MenuTitle, Popover, usePopover } from '../components/shared/Overlay';
import { useTerms } from './ShellStatus';

function Notifications() {
  const pop = usePopover();
  return (
    <Popover
      open={pop.open}
      onClose={pop.close}
      align="right"
      width={280}
      label="Notifications"
      anchor={
        <button className="btn btn-ghost icon-btn" type="button" aria-label="Notifications" title="Notifications" aria-haspopup="true" aria-expanded={pop.open} onClick={pop.toggle}>
          <Icon name="bell" />
        </button>
      }
    >
      <MenuTitle>Notifications</MenuTitle>
      <div className="caption" style={{ padding: '4px 9px 8px' }}>
        No notifications. Urgent calls appear on Insights.
      </div>
    </Popover>
  );
}

export function Topbar({ onToggleNav }) {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const { open: helpOpen, toggleHelp } = useHelp();
  const terms = useTerms();

  useEffect(() => {
    const onKey = (e) => {
      const tag = document.activeElement ? document.activeElement.tagName : '';
      if (e.key === '/' && tag !== 'INPUT' && tag !== 'TEXTAREA' && tag !== 'SELECT' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    const q = query.trim();
    navigate('/calls', { state: { search: q } });
  };

  return (
    <header className="topbar" id="vl-topbar">
      <button className="btn btn-ghost icon-btn menu-btn" type="button" aria-label="Open navigation" onClick={onToggleNav}>
        <Icon name="menu" />
      </button>
      <form className="global-search" role="search" onSubmit={submit}>
        <label style={{ display: 'block' }}>
          <span className="sr-only">Search calls</span>
          <Icon name="search" />
          <input
            ref={inputRef}
            id="vl-search"
            type="search"
            placeholder={`Search calls by caller, phone number, or ${terms.communityLower}`}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <kbd>/</kbd>
        </label>
      </form>
      <div className="topbar-actions">
        <Notifications />
        <button className="btn btn-ghost icon-btn" type="button" aria-label="Help" title="Help (?)" aria-expanded={helpOpen} aria-haspopup="dialog" onClick={toggleHelp}>
          <Icon name="help" />
        </button>
        <ThemeToggle />
      </div>
    </header>
  );
}
